import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefHistoryOBGyHistoryDetailsOfCongenitalAnomalyDetailByID = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryDetailsOfCongenitalAnomaly/GetDetail?` + params, null);

export const GetRefHistoryOBGyHistoryDetailsOfCongenitalAnomalyList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryDetailsOfCongenitalAnomaly/GetList?` + params, null);

export const CreateRefHistoryOBGyHistoryDetailsOfCongenitalAnomaly = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryDetailsOfCongenitalAnomaly/Create`, data);

export const UpdateRefHistoryOBGyHistoryDetailsOfCongenitalAnomaly = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryDetailsOfCongenitalAnomaly/Update`, data);

export const DeleteRefHistoryOBGyHistoryDetailsOfCongenitalAnomaly = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryDetailsOfCongenitalAnomaly/Delete`, data);